import LoadMorePosts from './loadMorePosts';
import BlogSearch from './blog_search';

const $ = jQuery.noConflict();
'use strict';

const Pagination = {

	generatePagination: (maxPages, currentPage, status = 'posts')=> {
		const container = $('#fws-lf-pagination');
		container.empty();

		// Previous arrow
		if (currentPage > 1) {
			const prev = '' +
				'<span class="fws-lf-block__pagination-arrow fws-lf-block__pagination-arrow--prev">\n' +
				'    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M7.406 8.578L12 13.172l4.594-4.594L18 9.984l-6 6-6-6z"/></svg>\n' +
				'</span>';
			container.append(
				Pagination.createPaginationItem(
					prev,
					currentPage > 1 ? currentPage - 1 : null,
					currentPage === 1,
					'fws-lf-block__pagination-arrow fws-lf-block__pagination-arrow--prev',
					status
				)
			);
		}

		// Page numbers with ellipsis
		Pagination.generatePageNumbers(maxPages, currentPage, container, status);

		if (currentPage !== maxPages && maxPages !== 0) {
			// Next arrow
			const next = '' +
				'<span class="fws-lf-block__pagination-arrow fws-lf-block__pagination-arrow--next">\n' +
				'    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M7.406 8.578L12 13.172l4.594-4.594L18 9.984l-6 6-6-6z"/></svg>\n' +
				'</span>';
			container.append(
				Pagination.createPaginationItem(
					next,
					currentPage < maxPages ? currentPage + 1 : null,
					currentPage === maxPages,
					'fws-lf-block__pagination-arrow fws-lf-block__pagination-arrow--next',
					status
				)
			);
		}
	},

	createPaginationItem: function(label, pageNumber, isActive, additionalClass, status = 'posts') {
		const listItem = $('<span>', {class: additionalClass});
		if (pageNumber !== null) {
			listItem.click(function() {
				// scroll to top of page
				$('html, body').animate({
					scrollTop: $('body').offset().top
				}, 'slow');
				//
				BlogSearch.showLoader(false);
				//
				LoadMorePosts.page = pageNumber;
				if (status === 'posts') {
					LoadMorePosts.loadMorePosts(
						LoadMorePosts.prepareData(pageNumber)
					);
				}
				if (status === 'search') {
					BlogSearch.sendRequest(
						BlogSearch.prepareData(pageNumber),
					);
				}
			});
		}

		if (isActive) listItem.addClass('active');
		if (pageNumber === null) listItem.addClass('disabled');

		listItem.append($('<span>', {html: label}));

		return listItem;
	},

	generatePageNumbers: function(maxPages, currentPage, container, status = 'posts') {
		const firstPage = 1;
		const lastPage = maxPages;

		const maxVisiblePages = 4;

		if (maxPages <= maxVisiblePages) {
			for (let i = firstPage; i <= lastPage; i++) {
				container.append(Pagination.createPaginationItem(i, i, i === currentPage, 'fws-lf-block__pagination-number', status));
			}
		} else {
			const visiblePages = Pagination.calculateVisiblePages(currentPage, maxVisiblePages, maxPages);

			container.append(
				Pagination.createPaginationItem(
					firstPage,
					firstPage,
					firstPage === currentPage,
					'fws-lf-block__pagination-number',
					status
				)
			);

			if (visiblePages[0] > firstPage + 1) {
				container.append($('<span>', {text: '...', class: 'fws-lf-block__pagination-number disabled'}));
			}

			for (const i of visiblePages) {
				if (i > firstPage && i < lastPage) {
					container.append(
						Pagination.createPaginationItem(
							i,
							i,
							i === currentPage,
							'fws-lf-block__pagination-number',
							status
						)
					);
				}
			}

			if (visiblePages[visiblePages.length - 1] < lastPage - 1) {
				container.append($('<span>', {text: '...', class: 'fws-lf-block__pagination-number disabled'}));
			}

			container.append(
				Pagination.createPaginationItem(
					lastPage,
					lastPage,
					lastPage === currentPage,
					'fws-lf-block__pagination-number',
					status
				)
			);
		}
	},


	calculateVisiblePages: function(currentPage, maxVisiblePages, maxPages) {
		const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);

		let start = Math.max(currentPage - halfMaxVisiblePages, 1);
		let end = start + maxVisiblePages - 1;

		if (end > maxPages) {
			end = maxPages;
			start = Math.max(end - maxVisiblePages + 1, 1);
		}

		return Array.from({length: end - start + 1}, (_, i) => start + i);
	},
};

export default Pagination;
